import { ApplicationState } from '../reducers';
import type { DestinationState, ChoiceResponse } from 'ts/types';

export const destinationSelector = (
  state: ApplicationState,
): DestinationState => state.destination;

export const destinationChoicesSelector = (state: ApplicationState) =>
  destinationSelector(state).choices as ChoiceResponse[];

export const serviceIdSelector = (state: ApplicationState) =>
  destinationSelector(state).serviceId;

export const categorySelector = (state: ApplicationState) =>
  destinationSelector(state).category;

export const destinationDataSelector = (state: ApplicationState) =>
  destinationSelector(state).data;

export const destinationCoordinatesSelector = (state: ApplicationState) =>
  destinationDataSelector(state)?.coordinates;

export const destinationAlertDistanceValueSelector = (
  state: ApplicationState,
) => destinationSelector(state).destinationAlertDistanceValue as string;

export const destinationAlertDistanceUnitToTranslateSelector = (
  state: ApplicationState,
) =>
  destinationSelector(state).destinationAlertDistanceUnitToTranslate as string;

export const showDestinationModalSelector = (state: ApplicationState) =>
  destinationSelector(state).showDestinationModal as boolean;

export const garageSelector = (state: ApplicationState) =>
  destinationSelector(state).garages;
